/* Copyright (c) 2020-present CloudIO Inc */

import { pageAtom } from 'designer/atoms';
import {
  AnalyzeContext,
  AnalyzeIssue,
  AnalyzeResult,
} from 'layout/Sidebar/panels/TreeView/AnalyzeUtils';
import { itemWithDefaultValues } from 'registry/Components';
import { Item, RequiredItem } from '../../registry/Component.type';

export async function analyzeDateField({
  platform,
  appUid,
  pageId,
  itemId,
  mgr,
}: AnalyzeContext): Promise<AnalyzeResult> {
  const alerts: AnalyzeIssue[] = [];
  const autoFixes: (() => void)[] = [];
  const page = platform.getPage(appUid, pageId);
  if (!page) {
    return null;
  }
  const store = platform.getParentStore(appUid, pageId, itemId);
  const item = itemWithDefaultValues(page[itemId]) as RequiredItem<'DateField'>;
  const { viewAttribute, showTime, label } = item.props;

  if (!store) {
    alerts.push({
      key: `incomplete-${itemId}`,
      showItemId: itemId,
      alert: `Incomplete ${mgr.name}. Must be wrapped inside a Data Store Reference!`,
      itemId,
    });
    return [alerts, autoFixes];
  }
  if (!viewAttribute) {
    return [alerts, autoFixes];
  }
  await store.initializeAttributes();
  const attr = store.getAttribute(viewAttribute);

  if (!attr) {
    return [alerts, autoFixes];
  }

  if (showTime && attr.attributeType === 'Date') {
    const fix = () => {
      const _page = { ...platform.getPage(appUid, pageId) };
      const _item = _page[itemId] as Item<'DateField'>;
      const updatedItem: Item<'DateField'> = {
        ..._item,
        props: { ..._item.props, showTime: false },
      };
      _page[_item.itemId] = updatedItem;
      platform.setter(pageAtom, _page, {
        params: { appUid, pageId },
      });
    };
    alerts.push({
      key: `datefield-${itemId}`,
      showItemId: itemId,
      alert: `${mgr.name} ${label} is set to show time but the attribute is of type Date.`,
      itemId,
      fix,
    });
    autoFixes.push(fix);
  }

  return [alerts, autoFixes];
}
